import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type AuthzService from 'garaje/services/authz';
import type ReactRendererService from 'garaje/services/react-renderer';
import { Permission } from 'garaje/utils/ui-permissions';
import type { Root } from 'react-dom/client';

export default class LocationOverviewApprovalsController extends Controller {
  @service declare reactRenderer: ReactRendererService;
  @service declare authz: AuthzService;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    const { GlobalVisitorApprovals } = await import('reactRichComponents/visitors/GlobalVisitorApprovals');

    const companyPermissions = {
      canReviewInviteVisualComplianceApproval: this.authz.hasPermissionAtCurrentCompany(
        Permission.VISITORS_INVITE_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      ),
      canReviewInviteBlocklistApproval: this.authz.hasPermissionAtCurrentCompany(
        Permission.VISITORS_INVITE_BLOCKLIST_APPROVAL_REVIEW,
      ),
      canReviewInviteApprovalRequired: this.authz.hasPermissionAtCurrentCompany(
        Permission.VISITORS_INVITE_APPROVAL_REQUIRED_REVIEW,
      ),
      canReviewEntryVisualComplianceApproval: this.authz.hasPermissionAtCurrentCompany(
        Permission.VISITORS_ENTRY_VISUAL_COMPLIANCE_APPROVAL_REVIEW,
      ),
      canReviewEntryBlocklistApproval: this.authz.hasPermissionAtCurrentCompany(
        Permission.VISITORS_ENTRY_BLOCKLIST_APPROVAL_REVIEW,
      ),
    };

    this.root = await this.reactRenderer.render(
      GlobalVisitorApprovals,
      'react__location-overview__global_visitor_approvals',
      { companyPermissions },
    );
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
